module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("aCJS6"))).then(() => module.bundle.root('1iHdE'));